export default function Footer() {
  return (
    <footer class="w3-container w3-center">
      <p class="footer-text">
        <a href="/paid">Why is Seat Alert paid?</a> | ©
        <a href="/me" target="_top">Ethan McAuliffe</a> |&nbsp;
        <a href="https://status.seatalert.ca">Status</a>
      </p>
    </footer>
  );
}
